export default __webpack_public_path__ + "static/media/Yellow0001.1bbcb37e.png";